import React from "react";
import { ArrowLeftIcon, ArrowUpRightIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";
const flexMlsUrl = "http://link.flexmls.com/1z74lszlgxjo,15";
export function OpenHouses() {
  return <main className="flex min-h-screen w-full flex-col bg-amber-950 text-amber-50" data-id="element-128" data-mp="by5zbll209dw">
      <section className="flex flex-1 items-center px-6 py-16 sm:px-10 lg:px-14" data-id="element-129" data-mp="fzhfz1ly9k9y">
        <div className="mx-auto w-full max-w-3xl" data-id="element-130" data-mp="13niuqs9q1wxt">
          <Link to="/mls-listings" className="inline-flex items-center gap-2 text-sm font-bold text-amber-100 transition-[color] duration-200 hover:text-white" data-id="element-131" data-mp="18mlp9is2skrj">
            <ArrowLeftIcon size={17} aria-hidden="true" data-id="element-132" data-mp="yw0qnvcejg8m" />
            Back to MLS options
          </Link>
          <p className="mt-16 text-xs font-bold uppercase tracking-[0.18em] text-amber-300" data-id="element-133" data-mp="1mlbl6v35seeb">Treasure Coast</p>
          <h1 className="mt-5 font-display text-5xl leading-[0.92] sm:text-7xl" data-id="element-134" data-mp="1rctldgxcyay8">Available open houses.</h1>
          <p className="mt-7 max-w-xl text-lg leading-8 text-amber-100" data-id="element-135" data-mp="kpqg2m4u20or">
            Explore homes currently open for viewing, then connect with Teri to plan a visit that fits your schedule.
          </p>
          <a href={flexMlsUrl} target="_blank" rel="noreferrer" className="mt-10 inline-flex items-center gap-3 rounded-md bg-amber-200 px-5 py-3.5 text-sm font-bold text-stone-950 transition-[background-color] duration-200 hover:bg-amber-100" data-id="element-136" data-mp="ufa19yg0q6ms">
            View open houses
            <ArrowUpRightIcon size={17} aria-hidden="true" data-id="element-137" data-mp="zfnxmj89bs4z" />
          </a>
        </div>
      </section>
      <SiteFooter tone="warm" data-id="element-138" data-mp="1db9t998zxa6d" />
    </main>;
}